import UriTemplate from 'uri-templates';
import {context} from "../constants/context";
import {halClient} from "../hal";
import {BBModel} from "../bb_model";

const adminTime = {
    query(prms) {
        if (prms.day) {
            prms.date = prms.day.date;
        }
        if (!prms.edate && prms.date) {
            prms.edate = prms.date;
        }
        let url = '';
        if (prms.url) {
            ({url} = prms);
        }
        const href = url + `/api/${context.apiVersion}/{company_id}/time_data{?date,event_id,service_id,person_id}`;

        const uri = new UriTemplate(href).fillFromObject(prms || {});
        return new Promise((resolve, reject) => {
            halClient.$get(uri, {no_cache: false}).then((found) => {
                    return found.$get('events').then((events) => {
                            const eventItems = [];
                            for (const eventItem of Array.from(events)) {
                                const event = {};
                                event.times = [];
                                event.event_id = eventItem.event_id;
                                event.person_id = found.person_id;
                                for (const time of Array.from(eventItem.times)) {
                                    const ts = new BBModel.TimeSlot(time);
                                    event.times.push(ts);
                                }
                                eventItems.push(event);
                            }
                            return resolve(eventItems);
                        }
                    );
                }
                , (err) => {
                    return reject(err);
                }
            );

        });
    }
};

export {
    adminTime
}
